import Grid from "@material-ui/core/Grid";
import GPAP_Breadcrumb from "../GPAP_Breadcrumb";
import React from "react";
import NavigationMenu from "../navigation-menu/NavigationMenu";




// Destructure window.config for clarity
const { instand, static_files } = window.config;

// Reusable component for Navigation Menu
const renderNavigationMenu = (title, orange, items) => (
    <NavigationMenu
        title={title}
        orange={orange}
        items={items}
    />
);

export  const navigationOptions = !instand && (
    <Grid item xs={5}>
        <Grid item>
            {renderNavigationMenu("Data Submission", false, [
                { label: "Phenotypic Data", to: "/phenostore/" },
                { label: "Experiments & Files", to: "/submission/" },
            ])}
            {renderNavigationMenu("Data Analysis", true, [
                { label: "Genomic Analysis", to: "/nextgpap" },
                { label: "Cohort Creation", to: "/cohortapp/" },
            ])}
            {renderNavigationMenu("Data Management", false, [
                { label: "Browse Phenotypic Participants", to: "/phenobrowse/" },
                { label: "Browse Experiments & Files", to: "/management/" },
            ])}
        </Grid>
        <Grid item>
            <GPAP_Breadcrumb />
        </Grid>
    </Grid>
);